<div class="container_filter">
    <div class="header">
      <div class="title-description">
        <h2 class="filter-title">
          {{ "Catalogs.filter.title" | translate }}
        </h2>
        <p class="filter-description">
          {{ "filter.description" | translate }}
        </p>
      </div>
      <button class="close" (click)="close()">
        <img src="assets/icones/close.svg" alt="" />
      </button>
    </div>
  
    <div class="content">
      <div class="selection">
        <div class="import-and-selected">
          <ng-container *ngIf="catalogsFilters?.filters?.length > 0">
            <button class="select-saved-filter" [matMenuTriggerFor]="menu">
              <img src="assets/icones/import-filter.svg" alt="" />
              <small>{{ "filter.import" | translate }}</small>
            </button>
            <mat-menu #menu="matMenu" class="import-menu">
              <div class="filter_btn"
                *ngFor="let filter of catalogsFilters?.filters || []"
                
              >
                <span (click)="setFilter(filter)"
                >{{ filter.name }}</span>
                <button (click)="deleteFilter(filter)" >
                  <img src="assets/icones/delete_btn.svg" alt="">
                </button>
              </div>
            </mat-menu>
          </ng-container>
          <div class="applied-filters-count" (click)="clearFilters()">
            <span class="count">{{ getFiltersCount() }}</span>
            <span>{{ "filter.applied" | translate }}</span>
            <img src="assets/icones/clear-filter.svg" alt="" />
          </div>
        </div>
        <div
          class="filter-group"
          [class.filter-group-selected]="selectedGroup === 'basic_info'"
        >
          <div class="group-title" (click)="selectedGroup = 'basic_info'">
            <img src="assets/icones/info.svg" alt="" />
            <h3>{{ "Catalogs.filter.groups.basic_info" | translate }}</h3>
          </div>
          <div class="filters">
            <div class="filter" *ngIf="filter.basicInfoFilter.name">
              <span>
                {{ "Catalogs.filter.fields.name" | translate }} :
                {{ filter.basicInfoFilter.name }}
              </span>
              <img
                src="assets/icones/clear-filter.svg"
                alt=""
                (click)="filter.basicInfoFilter.name = undefined"
              />
            </div>
            <div class="filter" *ngIf="filter.basicInfoFilter.status">
              <span>
                {{ "Catalogs.filter.fields.status" | translate }} :
                {{
                  "Catalogs.values." + filter.basicInfoFilter.status
                    | translate
                }}
              </span>
              <img
                src="assets/icones/clear-filter.svg"
                alt=""
                (click)="filter.basicInfoFilter.status = undefined"
              />
            </div>
            <div class="filter" *ngIf="filter.basicInfoFilter.type">
              <span>
                {{ "Catalogs.filter.fields.type" | translate }} :
                {{
                  "Catalogs.values." + filter.basicInfoFilter.type
                    | translate
                }}
              </span>
              <img
                src="assets/icones/clear-filter.svg"
                alt=""
                (click)="filter.basicInfoFilter.type = undefined"
              />
            </div>
            <div class="filter"
            *ngIf="
              filter.basicInfoFilter.start_date_min || filter.basicInfoFilter.start_date_max
            "
          >
            <span>
              {{
                "Catalogs.filter.fields.start_date_min" | translate
              }} :
              <ng-container *ngIf="filter.basicInfoFilter.start_date_min">
                {{ "common.from" | translate }}
                {{ filter.basicInfoFilter.start_date_min }} 
              </ng-container>
              <ng-container *ngIf="filter.basicInfoFilter.start_date_max">
                {{ "common.to" | translate }}
                {{ filter.basicInfoFilter.start_date_max }} 
              </ng-container>
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                filter.basicInfoFilter.start_date_min = undefined;
                filter.basicInfoFilter.start_date_max = undefined
              "
            />
          </div>
            <div class="filter"
            *ngIf="
              filter.basicInfoFilter.end_date_min || filter.basicInfoFilter.end_date_max
            "
          >
            <span>
              {{
                "Catalogs.filter.fields.end_date_min" | translate
              }} :
              <ng-container *ngIf="filter.basicInfoFilter.end_date_min">
                {{ "common.from" | translate }}
                {{ filter.basicInfoFilter.end_date_min }} 
              </ng-container>
              <ng-container *ngIf="filter.basicInfoFilter.end_date_max">
                {{ "common.to" | translate }}
                {{ filter.basicInfoFilter.end_date_max }} 
              </ng-container>
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                filter.basicInfoFilter.end_date_min = undefined;
                filter.basicInfoFilter.end_date_max = undefined
              "
            />
          </div>

          </div>
        </div>
        <div
          class="filter-group"
          [class.filter-group-selected]="selectedGroup === 'rules'"
        >
          <div class="group-title" (click)="selectedGroup = 'rules'">
            <img src="assets/icones/organize.svg" alt="" />
            <h3>{{ "Catalogs.filter.groups.rules" | translate }}</h3>
          </div>
          <div class="filters">
            <div class="filter"
            *ngIf="
              filter.rulesFilter.decrement_min || filter.rulesFilter.decrement_max
            "
          >
            <span>
              {{
                "Catalogs.filter.fields.price_decrement" | translate
              }} :
              <ng-container *ngIf="filter.rulesFilter.decrement_min">
                {{ "common.from" | translate }}
                {{ filter.rulesFilter.decrement_min }} 
              </ng-container>
              <ng-container *ngIf="filter.rulesFilter.decrement_max">
                {{ "common.to" | translate }}
                {{ filter.rulesFilter.decrement_max }} 
              </ng-container>
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                filter.rulesFilter.decrement_min = undefined;
                filter.rulesFilter.decrement_max = undefined
              "
            />
          </div>
            <div class="filter"
            *ngIf="
              filter.rulesFilter.min_quantity || filter.rulesFilter.max_quantity
            "
          >
            <span>
              {{
                "Catalogs.filter.fields.order_quantity" | translate
              }} :
              <ng-container *ngIf="filter.rulesFilter.min_quantity">
                {{ "common.from" | translate }}
                {{ filter.rulesFilter.min_quantity }} 
              </ng-container>
              <ng-container *ngIf="filter.rulesFilter.max_quantity">
                {{ "common.to" | translate }}
                {{ filter.rulesFilter.max_quantity }} 
              </ng-container>
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="
                filter.rulesFilter.min_quantity = undefined;
                filter.rulesFilter.max_quantity= undefined
              "
            />
          </div>
          <div class="filter"
          *ngIf="
            filter.rulesFilter.increment_min || filter.rulesFilter.increment_max
          "
        >
          <span>
            {{
              "Catalogs.filter.fields.increment_min" | translate
            }} :
            <ng-container *ngIf="filter.rulesFilter.increment_min">
              {{ "common.from" | translate }}
              {{ filter.rulesFilter.increment_min }} 
            </ng-container>
            <ng-container *ngIf="filter.rulesFilter.increment_max">
              {{ "common.to" | translate }}
              {{ filter.rulesFilter.increment_max }} 
            </ng-container>
          </span>
          <img
            src="assets/icones/clear-filter.svg"
            alt=""
            (click)="
              filter.rulesFilter.increment_min = undefined;
              filter.rulesFilter.increment_max = undefined
            "
          />
        </div>
          </div>
        </div>
        <div
        class="filter-group"
        [class.filter-group-selected]="selectedGroup === 'products'"
      >
        <div class="group-title" (click)="selectedGroup = 'products'">
          <img src="assets/icones/orders.svg" alt="" />
          <h3>{{ "Catalogs.filter.groups.products" | translate }}</h3>
        </div>
        <div class="filters">
          <div class="filter" *ngIf="filter.productsFilter.product_name">
            <span>
              {{ "Catalogs.filter.fields.product_name" | translate }} :
              {{ filter.productsFilter.product_name }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="filter.productsFilter.product_name = undefined"
            />
          </div>
          <div class="filter"
          *ngIf="
            filter.productsFilter.nbr_products_min || filter.productsFilter.nbr_products_max
          "
        >
          <span>
            {{
              "Catalogs.filter.fields.nb_products_included_min" | translate
            }} :
            <ng-container *ngIf="filter.productsFilter.nbr_products_min">
              {{ "common.from" | translate }}
              {{ filter.productsFilter.nbr_products_min }} 
            </ng-container>
            <ng-container *ngIf="filter.productsFilter.nbr_products_max">
              {{ "common.to" | translate }}
              {{ filter.productsFilter.nbr_products_max }} 
            </ng-container>
          </span>
          <img
            src="assets/icones/clear-filter.svg"
            alt=""
            (click)="
              filter.productsFilter.nbr_products_min = undefined;
              filter.productsFilter.nbr_products_max = undefined
            "
          />
        </div>
          <div class="filter"
          *ngIf="
            filter.productsFilter.nbr_products_overriding_general_rule_min || filter.productsFilter.nbr_products_overriding_general_rule_max
          "
        >
          <span>
            {{
              "Catalogs.filter.fields.nb_products_overriding_min" | translate
            }} :
            <ng-container *ngIf="filter.productsFilter.nbr_products_overriding_general_rule_min">
              {{ "common.from" | translate }}
              {{ filter.productsFilter.nbr_products_overriding_general_rule_min }} 
            </ng-container>
            <ng-container *ngIf="filter.productsFilter.nbr_products_overriding_general_rule_max">
              {{ "common.to" | translate }}
              {{ filter.productsFilter.nbr_products_overriding_general_rule_max }} 
            </ng-container>
          </span>
          <img
            src="assets/icones/clear-filter.svg"
            alt=""
            (click)="
              filter.productsFilter.nbr_products_overriding_general_rule_min = undefined;
              filter.productsFilter.nbr_products_overriding_general_rule_max = undefined
            "
          />
        </div>
        <div class="filter" *ngIf="filter.productsFilter.brands.length > 0">
          <span>
            {{ "inventory.filter.fields.brands" | translate }} :
            {{ getBrandsNames() }}
          </span>
          <img
            src="assets/icones/clear-filter.svg"
            alt=""
            (click)="filter.productsFilter.brands = []"
          />
        </div>
        <div class="filter" *ngIf="filter.productsFilter.categories.length > 0">
          <span>
            {{ "inventory.filter.fields.categories" | translate }} :
            {{ getCategoriesNames() }}
          </span>
          <img
            src="assets/icones/clear-filter.svg"
            alt=""
            (click)="filter.productsFilter.categories = []"
          />
        </div>
        <div class="filter" *ngIf="filter.productsFilter.tags.length > 0">
          <span>
            {{ "inventory.filter.fields.tags" | translate }} :
            {{ getTagsNames() }}
          </span>
          <img
            src="assets/icones/clear-filter.svg"
            alt=""
            (click)="filter.productsFilter.tags = []"
          />
        </div>
      </div>
    
        </div>
        <div
        class="filter-group"
        [class.filter-group-selected]="selectedGroup === 'locations'"
      >
        <div class="group-title" (click)="selectedGroup = 'locations'">
          <img src="assets/icones/location.svg" alt="" />
          <h3>{{ "Catalogs.filter.groups.locations" | translate }}</h3>
        </div>
        <div class="filters">
          <div class="filter" *ngIf="filter.locationsFilter.locations.length > 0">
            <span>
              {{ "quotations_and_orders.filter.fields.locations" | translate }} :
              {{ getLocationsNames() }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="filter.locationsFilter.locations = []"
            />
          </div>
          <div class="filter" *ngIf="filter.locationsFilter.client_groups.length > 0">
            <span>
              {{ "quotations_and_orders.filter.fields.locations" | translate }} :
              {{ getGroupesNames() }}
            </span>
            <img
              src="assets/icones/clear-filter.svg"
              alt=""
              (click)="filter.locationsFilter.locations = []"
            />
          </div>
          <div class="filter"
          *ngIf="
            filter.locationsFilter.nbr_locations_min || filter.locationsFilter.nbr_locations_max
          "
        >
          <span>
            {{
              "Catalogs.filter.fields.nb_locationd_attached_min" | translate
            }} :
            <ng-container *ngIf="filter.locationsFilter.nbr_locations_min">
              {{ "common.from" | translate }}
              {{ filter.locationsFilter.nbr_locations_min }} 
            </ng-container>
            <ng-container *ngIf="filter.locationsFilter.nbr_locations_max">
              {{ "common.to" | translate }}
              {{ filter.locationsFilter.nbr_locations_max }} 
            </ng-container>
          </span>
          <img
            src="assets/icones/clear-filter.svg"
            alt=""
            (click)="
              filter.locationsFilter.nbr_locations_min = undefined;
              filter.locationsFilter.nbr_locations_max = undefined
            "
          />
        </div>
        </div>
        
        </div>

      </div>
      <div class="form">
        <ng-container *ngIf="selectedGroup === 'basic_info'">
          <div class="form-title">
            <img src="assets/icones/info.svg" alt="" />
            <h3>{{ "Catalogs.filter.groups." + selectedGroup | translate }}</h3>
          </div>
  
          <div class="inputs">
           
            <div class="field">
              <label for="name">{{
                "Catalogs.filter.fields.name" | translate
              }}</label>
              <input
                id="name"
                type="text"
                [(ngModel)]="filter.basicInfoFilter.name"
                [placeholder]="'Catalogs.filter.fields.name' | translate"
              />
            </div>
            <div class="field">
              <label for="">{{
                "Catalogs.filter.fields.status" | translate
              }}</label>
              <select [(ngModel)]="filter.basicInfoFilter.status">
                <option value="" disabled selected>
                  {{ "Catalogs.filter.fields.status" | translate }}
                </option>
                <option value="Approved">
                  {{ "Catalogs.values.Approved" | translate }}
                </option>
                <option value="Draft">
                  {{ "Catalogs.values.Draft" | translate }}
                </option>
                <option value="Inactive">
                  {{ "Catalogs.values.Inactive" | translate }}
                </option>
              </select>
            </div>
            <div class="field">
              <label for="">{{
                "Catalogs.filter.fields.type" | translate
              }}</label>
              <select [(ngModel)]="filter.basicInfoFilter.type">
                <option value="" disabled selected>
                  {{ "Catalogs.filter.fields.type" | translate }}
                </option>
                <option value="client">
                  {{ "Catalogs.values.client" | translate }}
                </option>
                <option value="agent">
                  {{ "Catalogs.values.agent" | translate }}
                </option>
              </select>
            </div>
            <div class="inputs-pair">
              <div class="field">
                <label for="start_date_min">{{
                  "Catalogs.filter.fields.start_date_min" | translate
                }}</label>
                    <input
                    id="start_date_min"
                    type="date"
                    [(ngModel)]="filter.basicInfoFilter.start_date_min"
                    [placeholder]="'Catalogs.filter.fields.start_date_min' | translate"
                    />
              </div>
              <div class="field">
                <label for="start_date_max">{{
                  "Catalogs.filter.fields.start_date_max" | translate
                }}</label>
                  <input
                  id="start_date_max"
                  type="date"
                  [(ngModel)]="filter.basicInfoFilter.start_date_max"
                  [placeholder]="'Catalogs.filter.fields.start_date_max' | translate"
                  />
              </div>
          </div>
            <div class="inputs-pair">
              <div class="field">
                <label for="end_date_min">{{
                  "Catalogs.filter.fields.end_date_min" | translate
                }}</label>
                    <input
                    id="end_date_min"
                    type="date"
                    [(ngModel)]="filter.basicInfoFilter.end_date_min"
                    [placeholder]="'Catalogs.filter.fields.end_date_min' | translate"
                    />
              </div>
              <div class="field">
                <label for="end_date_max">{{
                  "Catalogs.filter.fields.end_date_max" | translate
                }}</label>
                  <input
                  id="end_date_max"
                  type="date"
                  [(ngModel)]="filter.basicInfoFilter.end_date_max"
                  [placeholder]="'Catalogs.filter.fields.end_date_max' | translate"
                  />
              </div>
          </div>
          </div>
        </ng-container>
        <ng-container *ngIf="selectedGroup === 'rules'">
          <div class="form-title">
            <img src="assets/icones/organize.svg" alt="" />
            <h3>{{ "Catalogs.filter.groups." + selectedGroup | translate }}</h3>
          </div>
          <div class="inputs">
            <div class="inputs-pair">
              <div class="field">
                <label for="decrement_min">{{
                  "Catalogs.filter.fields.price_decrement_min" | translate
                }}</label>
                <input
                  id="decrement_min"
                  type="number"
                  min="0"
                  [max]="filter.rulesFilter.decrement_max || 1"
                  [(ngModel)]="filter.rulesFilter.decrement_min"
                  [placeholder]="
                    'Catalogs.filter.fields.price_decrement_min' | translate
                  "
                />
              </div>
              <div class="field">
                <label for="decrement_max">{{
                  "Catalogs.filter.fields.price_decrement_max" | translate
                }}</label>
                <input
                  id="nbr_contacts_max"
                  type="number"
                  [min]="filter.rulesFilter.decrement_min || 0"
                  [(ngModel)]="filter.rulesFilter.decrement_max"
                  [placeholder]="
                    'Catalogs.filter.fields.price_decrement_max' | translate
                  "
                />
              </div>
            </div>
            <div class="inputs-pair">
              <div class="field">
                <label for="quantity_min">{{
                  "Catalogs.filter.fields.order_quantity_min" | translate
                }}</label>
                <input
                  id="quantity_min"
                  type="number"
                  min="0"
                  [max]="filter.rulesFilter.max_quantity || 1"
                  [(ngModel)]="filter.rulesFilter.min_quantity"
                  [placeholder]="
                    'Catalogs.filter.fields.order_quantity_min' | translate
                  "
                />
              </div>
              <div class="field">
                <label for="quantity_max">{{
                  "Catalogs.filter.fields.order_quantity_max" | translate
                }}</label>
                <input
                  id="nbr_contacts_max"
                  type="number"
                  [min]="filter.rulesFilter.min_quantity|| 0"
                  [(ngModel)]="filter.rulesFilter.max_quantity"
                  [placeholder]="
                    'Catalogs.filter.fields.order_quantity_max' | translate
                  "
                />
              </div>
            </div>
            <div class="inputs-pair">
              <div class="field">
                <label for="increment_min">{{
                  "Catalogs.filter.fields.increment_min" | translate
                }}</label>
                <input
                  id="increment_min"
                  type="number"
                  min="0"
                  [max]="filter.rulesFilter.increment_max || 1"
                  [(ngModel)]="filter.rulesFilter.increment_min"
                  [placeholder]="
                    'Catalogs.filter.fields.increment_min' | translate
                  "
                />
              </div>
              <div class="field">
                <label for="increment_max">{{
                  "Catalogs.filter.fields.increment_max" | translate
                }}</label>
                <input
                  id="nbr_contacts_max"
                  type="number"
                  [min]="filter.rulesFilter.increment_min || 0"
                  [(ngModel)]="filter.rulesFilter.increment_max"
                  [placeholder]="
                    'Catalogs.filter.fields.increment_max' | translate
                  "
                />
              </div>
            </div>
          </div>
        </ng-container>
  
        <ng-container *ngIf="selectedGroup === 'products'">
          <div class="form-title">
            <img src="assets/icones/orders.svg" alt="" />
            <h3>{{ "Catalogs.filter.groups." + selectedGroup | translate }}</h3>
          </div>
          <div class="inputs">
            <div class="field">
              <label for="product_name">{{
                "Catalogs.filter.fields.product_name" | translate
              }}</label>
              <input
                id="product_name"
                type="text"
                [(ngModel)]="filter.productsFilter.product_name"
                [placeholder]="'Catalogs.filter.fields.product_name' | translate"
              />
            </div>
            <div class="inputs-pair">
              <div class="field">
                <label for="nb_products_included_min">{{
                  "Catalogs.filter.fields.nb_products_included_min" | translate
                }}</label>
                <input
                  id="nb_products_included_min"
                  type="number"
                  min="0"
                  [max]="filter.productsFilter.nbr_products_max || 1"
                  [(ngModel)]="filter.productsFilter.nbr_products_min"
                  [placeholder]="
                    'Catalogs.filter.fields.nb_products_included_min' | translate
                  "
                />
              </div>
              <div class="field">
                <label for="nb_products_included_max">{{
                  "Catalogs.filter.fields.nb_products_included_max" | translate
                }}</label>
                <input
                  id="nbr_contacts_max"
                  type="number"
                  [min]="filter.productsFilter.nbr_products_min || 0"
                  [(ngModel)]="filter.productsFilter.nbr_products_max"
                  [placeholder]="
                    'Catalogs.filter.fields.nb_products_included_max' | translate
                  "
                />
              </div>
            </div>
            <div class="inputs-pair">
              <div class="field">
                <label for="nb_products_overriding_min">{{
                  "Catalogs.filter.fields.nb_products_overriding_min" | translate
                }}</label>
                <input
                  id="nb_products_overriding_min"
                  type="number"
                  min="0"
                  [max]="filter.productsFilter.nbr_products_overriding_general_rule_max || 1"
                  [(ngModel)]="filter.productsFilter.nbr_products_overriding_general_rule_min"
                  [placeholder]="
                    'Catalogs.filter.fields.nb_products_overriding_min' | translate
                  "
                />
              </div>
              <div class="field">
                <label for="nb_products_overriding_max">{{
                  "Catalogs.filter.fields.nb_products_overriding_max" | translate
                }}</label>
                <input
                  id="nbr_contacts_max"
                  type="number"
                  [min]="filter.productsFilter.nbr_products_overriding_general_rule_min || 0"
                  [(ngModel)]="filter.productsFilter.nbr_products_overriding_general_rule_max"
                  [placeholder]="
                    'Catalogs.filter.fields.nb_products_overriding_max' | translate
                  "
                />
              </div>
            </div>
            <div class="field equality_field">
              <label for="">{{
                "inventory.filter.fields.brands" | translate
              }}</label>
              <mat-chip-list #brandsChipList>
                <mat-chip
                  *ngFor="let brand of filter.productsFilter.brands; index as i"
                  (removed)="filter.productsFilter.brands.splice(i, 1)"
                >
                  {{ brand.name }}
                  <button matChipRemove>
                    <mat-icon style="color: #868e96">cancel</mat-icon>
                  </button>
                </mat-chip>
                <input
                  class="input_chip"
                  [placeholder]="'inventory.filter.fields.brands' | translate"
                  #fruitInput
                  (input)="filterBrands()"
                  [(ngModel)]="brandsFilterKey"
                  [ngModelOptions]="{ standalone: true }"
                  [matAutocomplete]="brandsAutoComplete"
                  [matChipInputFor]="brandsChipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                />
              </mat-chip-list>
              <mat-autocomplete #brandsAutoComplete="matAutocomplete">
                <ng-container *ngIf="filteredBrands$ | async as brands">
                  <mat-option
                    *ngFor="let brand of brands"
                    [value]="brand.id"
                    (click)="selectBrand(brand)"
                  >
                    {{ brand.name }}
                  </mat-option>
                </ng-container>
              </mat-autocomplete>
            </div>
            <div class="field equality_field">
              <label for="">{{
                "inventory.filter.fields.categories" | translate
              }}</label>
              <mat-chip-list #categoriesChipList>
                <mat-chip
                  *ngFor="
                    let category of filter.productsFilter.categories;
                    index as i
                  "
                  (removed)="filter.productsFilter.categories.splice(i, 1)"
                >
                  {{ category.name }}
                  <button matChipRemove>
                    <mat-icon style="color: #868e96">cancel</mat-icon>
                  </button>
                </mat-chip>
                <input
                  class="input_chip"
                  [placeholder]="'inventory.filter.fields.categories' | translate"
                  #fruitInput
                  (input)="filterCategories()"
                  [(ngModel)]="categoriesFilterKey"
                  [ngModelOptions]="{ standalone: true }"
                  [matAutocomplete]="categoriesAutoComplete"
                  [matChipInputFor]="categoriesChipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                />
              </mat-chip-list>
              <mat-autocomplete #categoriesAutoComplete="matAutocomplete">
                <ng-container *ngIf="filteredCategories$ | async as categories">
                  <mat-option
                    *ngFor="let category of categories"
                    [value]="category.id"
                    (click)="selectCategory(category)"
                  >
                    {{ category.name }}
                  </mat-option>
                </ng-container>
              </mat-autocomplete>
            </div>
            <div class="field equality_field">
              <label for="">{{ "inventory.filter.fields.tags" | translate }}</label>
              <mat-chip-list #tagsChipList>
                <mat-chip
                  *ngFor="let tag of filter.productsFilter.tags; index as i"
                  (removed)="filter.productsFilter.tags.splice(i, 1)"
                >
                  {{ tag.name }}
                  <button matChipRemove>
                    <mat-icon style="color: #868e96">cancel</mat-icon>
                  </button>
                </mat-chip>
                <input
                  class="input_chip"
                  [placeholder]="'inventory.filter.fields.tags' | translate"
                  #fruitInput
                  (input)="filterTags()"
                  [(ngModel)]="tagsFilterKey"
                  [ngModelOptions]="{ standalone: true }"
                  [matAutocomplete]="tagsAutoComplete"
                  [matChipInputFor]="tagsChipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                />
              </mat-chip-list>
              <mat-autocomplete #tagsAutoComplete="matAutocomplete">
                <ng-container *ngIf="filteredTags$ | async as tags">
                  <mat-option
                    *ngFor="let tag of tags"
                    [value]="tag.id"
                    (click)="selectTag(tag)"
                  >
                    {{ tag.name }}
                  </mat-option>
                </ng-container>
              </mat-autocomplete>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="selectedGroup === 'locations'">
          <div class="form-title">
            <img src="assets/icones/location.svg" alt="" />
            <h3>{{ "Catalogs.filter.groups." + selectedGroup | translate }}</h3>
          </div>
          <div class="inputs">
            <div class="field equality_field">
              <label for="">{{
                "quotations_and_orders.filter.fields.locations" | translate
              }}</label>
              <mat-chip-list #locationsChipList>
                <mat-chip
                  *ngFor="
                    let location of filter.locationsFilter.locations;
                    index as i
                  "
                  (removed)="filter.locationsFilter.locations.splice(i, 1)"
                >
                  {{ location.name }}
                  <button matChipRemove>
                    <mat-icon style="color: #868e96">cancel</mat-icon>
                  </button>
                </mat-chip>
                <input
                  class="input_chip"
                  [placeholder]="'quotations_and_orders.filter.fields.locations' | translate"
                  #fruitInput
                  (input)="filterLocations()"
                  [(ngModel)]="locationFilterKey"
                  [ngModelOptions]="{ standalone: true }"
                  [matAutocomplete]="locationsAutoComplete"
                  [matChipInputFor]="locationsChipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                />
              </mat-chip-list>
              <mat-autocomplete #locationsAutoComplete="matAutocomplete">
                <ng-container *ngIf="filterlocations$ | async as locations">
                  <mat-option
                    *ngFor="let location of locations"
                    [value]="location.id"
                    (click)="selectLocation(location)"
                  >
                    {{ location.name }}
                  </mat-option>
                </ng-container>
              </mat-autocomplete>
            </div>
            <div class="field">
              <label for="client_groups">{{
                "Catalogs.filter.fields.client_groups" | translate
              }}</label>
              <mat-chip-list #clientGroupsChipList>
                <mat-chip
                  *ngFor="
                    let clientGroup of filter.locationsFilter.client_groups;
                    index as i
                  "
                  (removed)="filter.locationsFilter.client_groups.splice(i, 1)"
                >
                  {{ clientGroup.name }}
                  <button matChipRemove>
                    <mat-icon style="color: #868e96">cancel</mat-icon>
                  </button>
                </mat-chip>
                <input
                  class="input_chip"
                  [placeholder]="'Catalogs.filter.fields.client_groups' | translate"
                  #fruitInput
                  (input)="filterClientGroups()"
                  [(ngModel)]="clientGroupFilterKey"
                  [ngModelOptions]="{ standalone: true }"
                  [matAutocomplete]="clientGroupsAutoComplete"
                  [matChipInputFor]="clientGroupsChipList"
                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                />
              </mat-chip-list>
              <mat-autocomplete #clientGroupsAutoComplete="matAutocomplete">
                <ng-container *ngIf="filteredClientGroups$ | async as clientGroups">
                  <mat-option
                    *ngFor="let clientGroup of clientGroups"
                    [value]="clientGroup.id"
                    (click)="selectClientGroup(clientGroup)"
                  >
                    {{ clientGroup.name }}
                  </mat-option>
                </ng-container>
              </mat-autocomplete>
            </div>
            <div class="inputs-pair">
              <div class="field">
                <label for="nb_locationd_attached_min">{{
                  "Catalogs.filter.fields.nb_locationd_attached_min" | translate
                }}</label>
                <input
                  id="nb_locationd_attached_min"
                  type="number"
                  min="0"
                  [max]="filter.locationsFilter.nbr_locations_max || 1"
                  [(ngModel)]="filter.locationsFilter.nbr_locations_min"
                  [placeholder]="
                    'Catalogs.filter.fields.nb_locationd_attached_min' | translate
                  "
                />
              </div>
              <div class="field">
                <label for="nb_locationd_attached_max">{{
                  "Catalogs.filter.fields.nb_locationd_attached_max" | translate
                }}</label>
                <input
                  id="nb_locationd_attached_max"
                  type="number"
                  [min]="filter.locationsFilter.nbr_locations_min || 0"
                  [(ngModel)]="filter.locationsFilter.nbr_locations_max"
                  [placeholder]="
                    'Catalogs.filter.fields.nb_locationd_attached_max' | translate
                  "
                />
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  
    <div class="footer submet_btns">
      <button class="save_btn_pop_up cancel_btn_pop_up" (click)="close()">
          <span>{{"common.cancel"|translate | uppercase}}</span>
          <img src="../../../../../assets/icones/arrow_back.svg" alt="">
      </button>
      <div class="save-apply">
        <div class="save-filter-form" *ngIf="toggleSaveFilterForm && getFiltersCount() > 0">
          <div class="label-action">
            <label for="filter_name">{{
              "inventory.filter.filter_name" | translate
            }}</label>
            <div class="actions">
              <button class="cancel-btn" (click)="toggleSaveFilter()">{{ "common.cancel" | translate }}</button>
              <button class="save-btn" (click)="save()">
                {{ "common.save" | translate | uppercase }}
              </button>
            </div>
          </div>
          <input
            id="filter_name"
            type="text"
            class="filter-name-input"
            [placeholder]="'inventory.filter.filter_name' | translate"
            [(ngModel)]="filterName"
            [formControl]="filterNameControl"
          />
          <span class="error_ms" *ngIf="filterNameControl?.touched && filterNameControl?.errors">
            {{ "common.required_field" | translate }}
          </span>
        </div>
        <button
          class="save save_filter"
          [disabled]="getFiltersCount() <= 0" *ngIf="!toggleSaveFilterForm"
          (click)="toggleSaveFilter()"
        >
          <img src="assets/icones/save-filter.svg" alt="" />
          <small>{{ "filter.save" | translate }}</small>
        </button>
        <button class="save_btn_pop_up blue_btn" (click)="apply()">
          <small>{{ "filter.apply" | translate | uppercase }}</small>
          <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
        </button>
      </div>
    </div>
  </div>
  